/**
 * @generated SignedSource<<59597a1fa3aa1100f041f46488a65d37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type lessonTypeHasRateForMembershipType_lessonType$data = {
  readonly lessonTypeRates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly allMembershipTypes: boolean;
        readonly membershipTypes: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "lessonTypeHasRateForMembershipType_lessonType";
};
export type lessonTypeHasRateForMembershipType_lessonType$key = {
  readonly " $data"?: lessonTypeHasRateForMembershipType_lessonType$data;
  readonly " $fragmentSpreads": FragmentRefs<"lessonTypeHasRateForMembershipType_lessonType">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "lessonTypeHasRateForMembershipType_lessonType"
};

(node as any).hash = "67fda550701751562b4a26dc128f01a3";

export default node;
